import { render, staticRenderFns } from "./Componente.vue?vue&type=template&id=c5762d44"
import script from "./Componente.vue?vue&type=script&lang=js"
export * from "./Componente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports